import { Typography, useTheme } from '@mui/material';
import { TagChip } from 'components/ui';
import { TableContext } from 'pages/PatientsPage';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const AgeFilterChip = () => {
  const { t } = useTranslation();
  const theme = useTheme()
  const { filters, setFilters } = useContext(TableContext);

  function deleteFilter() {
    setFilters({
      ...filters,
      startAge: 0,
      endAge: 130,
    });
  }

  if (filters?.startAge === 0 && filters?.endAge === 130) return null;

  const label = `${filters?.startAge}-${filters?.endAge}`;

  return (
    <TagChip
      tag={
        <>
          <Typography
            component="span"
            color={theme.palette.colors.black}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {`${t('Age')}: `}
          </Typography>
          <Typography
            component="span"
            color={theme.palette.colors.blue100}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {label}
          </Typography>
        </>
      }
      handleDelete={deleteFilter}
      isCanDelete
      iconColor={theme.palette.colors.blue100}
    />
  );
};
